module.exports = __webpack_public_path__ + "img/new_22_1.2e1b3105.jpg";